import { render } from "./SwayVisaCard.vue?vue&type=template&id=1521878b&scoped=true"
import script from "./SwayVisaCard.vue?vue&type=script&lang=js"
export * from "./SwayVisaCard.vue?vue&type=script&lang=js"

import "./SwayVisaCard.vue?vue&type=style&index=0&id=1521878b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1521878b"]])

export default __exports__